"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx } from "@/helpers/clsx";
import { mapLogosToGrid } from "@/helpers/mapLogosToGrid";
import React, { useLayoutEffect } from "react";
export const GridBackground = ({
  children,
  className,
  logos
}: {
  children?: React.ReactNode;
  className?: string;
  logos?: any;
}) => {
  const [logoId, setLogoId] = React.useState<string>();
  const logoRef = React.useRef<SVGSVGElement>(null);
  const ref = React.useRef<HTMLDivElement>(null);
  const mappedLogos = React.useMemo(() => {
    if (!logos) return;
    return mapLogosToGrid(logos?.map((logo: any) => logo.id));
  }, []);
  useLayoutEffect(() => {
    if (!ref.current) return;
    if (!ref.current.classList.contains("squares")) return;
    let timeout;
    const getClosestSquare = (e: MouseEvent) => {
      if (document.getElementById("cmdk")) return;
      if (!ref.current) return;
      const style = getComputedStyle(ref.current);
      const size = Number(style.getPropertyValue("--size").slice(0, -2));
      const rect = ref.current.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      const x = e.clientX - centerX;
      const y = e.clientY - centerY;
      if (e.clientY < rect.top || e.clientY > rect.bottom || e.clientX < rect.left || e.clientX > rect.right || (e.target as HTMLElement)?.closest(".hero")) {
        clearTimeout(timeout);
        document.body.classList.remove("cursor-unicorn");
        return;
      }
      const cx1 = style.getPropertyValue("--square1x");
      const cy1 = style.getPropertyValue("--square1y");
      const x1 = Math.round(x / size);
      const y1 = Math.round(y / size);
      ref.current.style.setProperty("--square1x", `${x1}`);
      ref.current.style.setProperty("--square1y", `${y1}`);
      const x2 = x1 * -1;
      const y2 = y1 * -1;
      ref.current.style.setProperty("--square2x", `${x2}`);
      ref.current.style.setProperty("--square2y", `${y2}`);
      if (logos && (cx1 !== String(x1) || cy1 !== String(y1))) {
        // pick a random logo
        const logo_0 = mappedLogos?.[x1]?.[y1] ?? logos[Math.floor(Math.random() * logos.length)]?.id;
        logoRef.current?.querySelector("use")?.setAttribute("href", `/_static/sprites/logos.svg#${logo_0}`);
        const isInTheMiddle = Math.abs(x1) <= 4 && Math.abs(y1) <= 1;
        if (isInTheMiddle) {
          logoRef.current?.classList.add("logo-middle");
        } else {
          logoRef.current?.classList.remove("logo-middle");
        }

        // set the logo as the background image
        if (!logoId) {
          setLogoId(logo_0);
        }
      }
      clearTimeout(timeout);
      if (x1 === x2 && y1 === y2) {
        ref.current?.classList.add("overlapping-squares");
        document.body.classList.add("cursor-unicorn");
      } else {
        ref.current.classList.remove("overlapping-squares");
        timeout = setTimeout(() => document.body.classList.remove("cursor-unicorn"), 1000);
      }
    };
    document.body?.addEventListener("mousemove", getClosestSquare);
    return () => {
      document.body?.removeEventListener("mousemove", getClosestSquare);
      clearTimeout(timeout);
    };
  }, []);
  return <div className={clsx("grid-bg fade-around flex", className)} ref={ref}>
      {children}
      {logoId && <svg className="logo opacity-20" ref={logoRef} aria-label={`${logoId} logo`}>
          <use href={`/_static/sprites/logos.svg#${logoId}`} />
        </svg>}
    </div>;
};

/* 
React.useLayoutEffect(() => {
    if (!ref.current) return;
    if (!ref.current.classList.contains("squares")) return;
    const sizeX = window.screen.availWidth / 100;
    const sizeY = 6;

    const getRandom = (min: number = 0, max: number) =>
      Math.floor(Math.random() * (max - min + 1) + min);

    const randomizeBlocks = () => {
      const x1 = getRandom(-sizeX / 2, 0);
      const y1 = getRandom(-sizeY / 2, sizeY / 2);
      const x2 = getRandom(0, sizeX / 2);
      const y2 = getRandom(-sizeY / 2, sizeY / 2);
      ref.current?.style.setProperty("--square1x", `${x1}`);
      ref.current?.style.setProperty("--square1y", `${y1}`);
      ref.current?.style.setProperty("--square2x", `${x2}`);
      ref.current?.style.setProperty("--square2y", `${y2}`);
    };

    let interval = setInterval(randomizeBlocks, 100);

    setTimeout(() => {
      clearInterval(interval);
      ref.current?.classList.remove("squares");
      //interval = setInterval(randomizeBlocks, 1000);
    }, 2000);

    return () => clearInterval(interval);
  }, []); */

export const GridPageBackground = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0"><GridBackground className="!z-[0] -mt-4 hidden ![--mask-size:90%] md:flex" /><div className="absolute inset-x-0 top-0 z-[0] mx-auto hidden h-[722px] w-[768px] bg-body md:flex" /><div className="absolute inset-x-0 top-0 z-[0] mx-auto hidden h-full w-[988px] bg-body md:flex" /><div className="absolute inset-0 z-[-1] bg-[radial-gradient(#151515,#0E0E0E_70%)]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};